import Api from '@umu/umu-api';
import { fetchData } from '@umu/umu-fetch';
import { IListResponse } from '@umu/umu-types';
import { IMarketCategory } from 'market/@marketCommon/interface/category';

export enum CategoryType {
    ALL = '0',
    COMMON = '1',
    COURSE = '2',
    CIRCLE = '3',
}

interface IInput {
    category_id?: string;
    type: CategoryType;
}

/**
 * 获取分类列表
 * @returns IMarketCategory[]
 */
export const getCategorys = (input: IInput): Promise<IListResponse<IMarketCategory>> => {
    return fetchData(Api.Path.MARKET_CATEGORYS, input).then((res: IListResponse<IMarketCategory>) => {
        return res;
    });
};
